export default __webpack_public_path__ + "static/media/multi-user-icon.1604b2ee.svg";